import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

const getOutagesApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/outage/get', {});
  return response.data.data || response.data || [];
};

const reportOutageApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/outage/report', payload);
  return response.data;
};

const updateOutageApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/outage/update', payload);
  return response.data;
};

export const useOutages = () => {
  return useQuery({
    queryKey: ['outages'],
    queryFn: getOutagesApi,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useReportOutage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reportOutageApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['outages'] });
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};

export const useUpdateOutage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOutageApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['outages'] });
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};
